import React from 'react'

function TopNav() {
  return (
     <header className="top-header">
            <div className="d-flex align-items-center">
              <button className="btn d-lg-none me-2" id="sidebarToggle">
                <span className="material-symbols-outlined">menu</span>
              </button>
              <div className="search-bar d-none d-md-flex">
                <span className="material-symbols-outlined">search</span>
                <input
                  type="text"
                  placeholder="Search courses, assignments..."
                />
              </div>
            </div>
            <div className="header-tools">
              <button className="tool-btn">
                <span className="material-symbols-outlined">notifications</span>
              </button>
              <button className="tool-btn">
                <span className="material-symbols-outlined">chat_bubble</span>
              </button>
            </div>
          </header>
  )
}

export default TopNav